define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action",
	"csi/table/Delete"
], function(declare,_,csiAction,Delete) {

	return declare(Delete, {

		getString: function(/*String*/suffix, /*String[]?*/params) {
			if (suffix == csiAction.SUFFIX_CONFIRM) {
				var version = this.getNode();
				if (version) {
					var parent = this.m_cache.getNode(version.__Parent__);

					params = [parent.$Name, params[0]];
					suffix += "_InVersion";
				}
			}
			return this.inherited(arguments, [suffix, params]);
		}

	});
});